<template>
    <div class="centered-container">
        <SimpleModal v-if="showModal" class="activate-premium-plan-modal" :show-close-button="false" :smPadding="true"
            @close="$emit('close')">
            <template v-slot:body>
                <div class="activate-premium-plan-modal__body">
                    <div class="activate-premium-plan-modal__body__wrapper d-flex flex-column flex-lg-row gap-5">
                        <div class="activate-premium-plan-modal__body__left d-flex flex-column text-center expanded">

                            <p class="mx-auto" v-if="infoText" style="color: #f52d2d; max-width: 250px;">
                                {{ infoText }}
                            </p>

                            <template
                                v-if="user.prospecting_tool_attributes && user.prospecting_tool_attributes.currentSubscriptionPlan.hasDiscount">
                                <div class="activate-premium-plan-modal__body__premium-plus mb-2">
                                    <p class="w-100 mx-auto mb-0 d-flex justify-content-between gap-3">
                                        <span>{{
                                            user.prospecting_tool_attributes.subscriptionPlans.premium_plus.nameShort
                                        }}</span>
                                        <span class="price"><span class="price-number"><span class="line" />£{{
                                            user.prospecting_tool_attributes.subscriptionPlans.premium_plus.subscriptionFullPrice
                                                }}</span> p/m + VAT </span>
                                    </p>
                                </div>

                                <div class="activate-premium-plan-modal__body__discount mb-5">
                                    <span style="color: #34cc7e">Trial period Promo discount</span>
                                    <span>£{{
                                        user.prospecting_tool_attributes.subscriptionPlans.premium_plus.subscriptionPrice
                                    }} p/m + VAT </span>
                                </div>
                            </template>

                            <template v-else>
                                <div class="activate-premium-plan-modal__body__premium-plus mb-3">
                                    <p class="w-100 mx-auto mb-0 d-flex justify-content-between gap-3">
                                        <span>{{
                                            user.prospecting_tool_attributes.subscriptionPlans.premium_plus.nameShort
                                        }}</span>
                                        <span>£{{
                                            user.prospecting_tool_attributes.subscriptionPlans.premium_plus.subscriptionFullPrice
                                        }} p/m + VAT </span>
                                    </p>
                                </div>
                            </template>

                            <div class="activate-premium-plan-modal__body__list w-fit mx-auto"
                                style="text-align: start;">
                                <div key="unlimited">
                                    <KrispyCheckIcon />
                                    <p>Unlimited Stock Finder data - <br />
                                        <span
                                            style="color: var(--premium-plus-color); font-weight: 800; display: inline-block;">
                                            Sales & Lettings
                                        </span>
                                    </p>
                                </div>
                                <div key="company-landlord-access">
                                    <KrispyCheckIcon />
                                    <p>
                                        Unlimited
                                        <span
                                            style="color: var(--premium-plus-color); font-weight: 800; display: inline-block;">
                                            Company landlord
                                        </span>
                                        details
                                    </p>
                                </div>
                                <div key="hmo-access">
                                    <KrispyCheckIcon />
                                    <p>
                                        Unlimited
                                        <span
                                            style="color: var(--premium-plus-color); font-weight: 800; display: inline-block;">
                                            HMO ownership
                                        </span>
                                        details
                                    </p>
                                </div>
                                <div key="land-locator-access">
                                    <KrispyCheckIcon />
                                    <p>
                                        Unlimited
                                        <span
                                            style="color: var(--premium-plus-color); font-weight: 800; display: inline-block;">
                                            Land Locator
                                        </span>
                                        access
                                    </p>
                                </div>
                                <div key="no-of-postcodes">
                                    <KrispyCheckIcon />
                                    <p>Up to
                                        <span
                                            style="color: var(--premium-plus-color); font-weight: 800; display: inline-block;"
                                            key="no-of-postcodes">
                                            {{
                                                user.prospecting_tool_attributes.subscriptionPlans.premium_plus.postcodes
                                            }}
                                        </span>
                                        postcodes
                                    </p>
                                </div>
                                <div key="auto-matching">
                                    <KrispyCheckIcon />
                                    <p>Database auto matching</p>
                                </div>
                                <div key="enquiries">
                                    <KrispyCheckIcon />
                                    <p>Qualified tenant enquiries</p>
                                </div>
                                <div key="free-feed">
                                    <KrispyCheckIcon />
                                    <p>Free feed integration</p>
                                </div>
                            </div>

                            <button type="button" class="btn btn--transparent-outlined mt-auto"
                                @click.prevent="$emit('close')">
                                Maybe later
                            </button>
                        </div>

                        <div class="activate-premium-plan-modal__body__right">
                            <h5>Please accept our subscription Terms & Conditions</h5>
                            <div class="custom-separator" />
                            <div class="activate-premium-plan-modal-tc">
                                <p>
                                    Hi {{ user.public_name }},
                                </p>
                                <p v-if="selectedPlan">
                                    Thank you for choosing to upgrade to our {{ selectedPlan.name }} - giving you more
                                    value from one of the
                                    UK's fastest growing property portal for Estate Agents.
                                </p>
                                <p>
                                    Below you'll find a breakdown of your contract and associated terms.
                                </p>
                                <p>
                                    Once you've signed the agreement and completed your Direct Debit mandate, we'll have
                                    you up and running and
                                    taking advantage our full suite of live tools, and not to mention all of the other
                                    tools we'll be launching
                                    in no time!
                                </p>
                                <p>
                                    We look forward to working with you!
                                </p>
                                <p>
                                    The krispyhouse.com Team
                                </p>
                                <strong class="mt-5" v-if="selectedPlan">
                                    {{ selectedPlan.name }} Breakdown
                                </strong>
                                <p v-if="selectedPlan">
                                    Your Stock Finder account includes up to {{ selectedPlan.postcodes }} out code
                                    districts. More can be
                                    requested and any additional out codes districts will be subject to a price change.
                                </p>
                                <p v-if="selectedPlan">
                                    {{ selectedPlan.name }} package cost:
                                </p>
                                <p v-if="selectedPlan">
                                    Subtotal: £{{ selectedPlan.subscriptionPrice }}
                                </p>
                                <p v-if="selectedPlan">
                                    VAT: £{{ selectedPlan.subscriptionVAT }}
                                </p>
                                <p v-if="selectedPlan">
                                    Total: £{{ selectedPlan.subscriptionPriceWithVAT }}
                                </p>
                                <p>
                                    Effective date: {{ new Date().toLocaleDateString("en-GB", {
                                        year: 'numeric', month:
                                            'long', day: 'numeric'
                                    })
                                    }}
                                </p>
                                <h5>Terms & Conditions.</h5>
                                <p>
                                    By completing this Subscription Agreement you confirm that you have read, understood
                                    and accept our
                                    <a href="/agent-terms-and-conditions" target="_blank">Agent Terms and Conditions</a>
                                    and
                                    <a href="/privacy-policy" target="_blank">Privacy Policy.</a>
                                    By signing the Subscription Agreement you certify that you are authorised to sign
                                    and enter into this
                                    legally binding contract, on behalf of the company you are representing.
                                </p>
                                <p>
                                    A signed Subscription Agreement and any documents expressly referred to in the
                                    Subscription Agreement
                                    represents the entire agreement between Krispyhouse Ltd t/a krispyhouse.com and you
                                    (as the client) and
                                    supersede all previous arrangements, understanding or agreement between us.
                                </p>
                                <h5>
                                    Agreement Term:
                                </h5>
                                <p v-if="selectedPlan">
                                    The term of this Subscription Agreement shall commence on the Effective Date and
                                    continue thereafter for a
                                    period of {{ selectedPlan.contractLength }} months (“Initial Term”).
                                    Unless otherwise terminated in accordance with the Terms and Conditions, upon the
                                    expiration of the Initial
                                    Term, the Subscription Agreement will automatically renew for successive {{
                                        selectedPlan.contractLength ===
                                        12 && 'twelve' }} ({{ selectedPlan.contractLength }}) month periods unless either
                                    party provides the other
                                    with written notice of non-renewal
                                    at
                                    least thirty (30) days
                                    prior to the expiration of the then-current Term. “Term” means the Initial Term and
                                    any renewal terms(s) of
                                    this Subscription Agreement.
                                </p>
                                <p>
                                    All additional postcode sectors added during the Initial Term will be added for the
                                    remainder of the Initial
                                    Term on an bi-annual pro-rata basis and will renew on the terms above.
                                </p>
                            </div>
                            <div class="activate-premium-plan-modal__form mt-4 px-2">
                                <div class="form-group">
                                    <div class="d-flex gap-2">
                                        <input type="checkbox" name="terms" v-model="formData.terms"
                                            v-validate="{ required: true }" data-vv-as="accept terms" />
                                        <span>I confirm that I have read and accept to be bound by the <a
                                                href="/terms-and-conditions" target="_blank">Terms & Conditions</a> and
                                            that I am an authorised company signatory</span>
                                    </div>
                                    <span class="form-error">{{ errors.first('terms') }}</span>
                                </div>

                                <button type="submit" class="btn btn--primary btn--xs mx-auto get-started-btn w-100"
                                    :disabled="errors.any() || isLoading" @click.prevent="onUpgrade">
                                    Upgrade
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </SimpleModal>
    </div>
</template>

<script>
import SimpleModal from '@components/partials/modal/SimpleModal.vue';
import { mapState } from 'vuex';

const KrispyCheckIcon = () => import('@components/partials/icons/KrispyCheckIcon.vue');

export default {
    $_veeValidate: {
        validator: 'new', // give me my own validator scope.
    },
    components: {
        SimpleModal,
        KrispyCheckIcon,
    },
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        infoText: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            formData: {
                terms: false,
            },
            isLoading: false,
        };
    },
    computed: {
        ...mapState('user', ['user']),
        selectedPlan() {
            return this.user.prospecting_tool_attributes.subscriptionPlans.premium_plus;
        },
    },
    methods: {
        onUpgrade() {
            this.$validator.validate().then((valid) => {
                if (valid) {
                    this.isLoading = true;
                    this.axios.post('/api/subscriptions/upgrade', this.formData)
                        .then(() => {
                            window.showToastSuccess('Your plan is now upgraded to premium plus. Enjoy the new features!');
                            this.formData = {
                                terms: false,
                            };
                            this.$emit('close');
                        })
                        .catch(() => {
                            window.showToastError('An error occured while trying to upgrade your plan. Please contact krispyhouse support team.');
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                }
            });
        },
    },
};
</script>
